import appStore from 'store';

const store = {
  namespaced: true,
  mutations: {},
  actions: {}
};

appStore.registerModule('ProfitLossData', store);
